import React from "react";
import SelectMenu from "./select/index";
import SwitchField from "./toggle/index";
import TagManager from "../AddTags/index";
import MyCheckbox from "./checkbox/index";
import RadioGroupField from "./radio/index";
import TextEditor from "./text-editor/index";
import CommonInputField from "./input/index";
import DateRangePickerField from "./date-range/index";
import DateTimeRangePicker from "./date-time-range/index";
import InstallmentSection from "./installment-section/index";

export const renderFormControl = (field) => {
  const { fieldKey } = field;

  switch (fieldKey) {
    case "checkbox":
      return <MyCheckbox {...field} />;
    case "tag":
      return <TagManager {...field} />;
    case "installment":
      return <InstallmentSection {...field} />;
    case "text":
      return <CommonInputField {...field} />;
    case "text-editor":
      return <TextEditor {...field} />;
    case "date-time-range":
      return <DateTimeRangePicker {...field} />;
    case "toggle":
      return <SwitchField {...field} />;
    case "radio":
      return <RadioGroupField {...field} />;
    case "select":
      return <SelectMenu {...field} />;
    case "date-range":
      return <DateRangePickerField {...field} />;
    default:
      return null;
  }
};
